import DialogEmptyState from './DialogEmptyState.component';

export default DialogEmptyState;
